// Shared constants for the GTM Consultancy site
export const LINKS = {
  cal: "https://cal.com/gtmconsultancy/chat",
  playbook: "https://gtm-consultancy-ehnbr7j.gamma.site/",
  linkedin: "https://linkedin.com/in/hamzagtm",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
